<template>
  <div id="app">

    <div class="lds-ripple" id="loading">
      <div></div><div></div>
    </div>

    <div class="top_heading">
    </div>
    <div class="progress-container">
      <div class="progress-bar" id="bar_progress"></div>
    </div>
    <header class="hidden_">

      <div class="container">
        <a href="https://www.iarc.fr" target="_blank" id="a_logo">
            <img id="logo" src="./assets/img/logo.svg" tite="International Agency for Research on Cancer">
        </a>

        <ul class="social">
            <li><a href="https://twitter.com/iarcwho" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/channel/UCw1sEvFsKqLLRmKQdaOSs9A" target="_blank"><i class="fab fa-youtube"></i></a></li>
            <li><a href="https://www.linkedin.com/company/102821/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
            <li><a href="https://www.iarc.fr/iarc-rss-feeds/" target="_blank"><i class="fas fa-rss"></i></a></li>
        </ul>

        <h1 class="title ml1" data-aos="fade-down" data-aos-duration="1500" id="main_title">
          <span class="text-wrapper">
            <span class="line line1"></span>
            <span class="letters">Global burden of <br/>gastrointestinal cancers</span>
            <span class="line line2"></span>
          </span>
        </h1>
        
        <div class="row">
          <p class="intro" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="2000"><strong>Gastrointestinal (GI)</strong> cancers account for <span class="number">1</span> in <span class="number">4</span> cancer cases and <span class="number">1</span> in <span class="number">3</span> cancer deaths globally. There is considerable variation in incidence and mortality rates across the world. <br/><br/>

          Gastric cancer incidence <strong>has decreased</strong> but colorectal cancer incidence has <strong>increased</strong> in formerly low-incidence regions. Liver and pancreatic cancer incidence has <strong>increased</strong> in some <strong>high-income regions</strong>. <br/><br/>
          
          Primary and secondary <strong>prevention</strong> remain key and include strategies to control tobacco, alcohol, and obesity, immunise populations against hepatitis B virus infection, and screen for colorectal cancers.
          
          <a href="#slide1" class="scroll" data-aos="fade-down" data-aos-duration="2500" data-aos-delay="2000">
            <span></span>Scroll</a>
          </p>
          
        </div>
      </div>

    </header>

    <!--<div id="spinLoading">
        <span></span>
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>
    </div>-->

    <!--<select name="theming" v-on:change="switchTheme">
      <option value="dark">Dark</option>
      <option value="iarc">IARC</option>
    </select>-->

    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>

    <footer class="hidden_">
      <a v-on:click="goToTop()" v-b-tooltip.hover title="Restart the story from top" id="goToTop">
        <i class="fas fa-redo-alt"></i>
      </a>  
    </footer>

  </div>
</template>

<script>

import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'app',
  components: {
  },
  mounted() {

    window.onscroll = ()=>{ this.checkScrolling() };

    this.findRoute();
    //var textWrapper = document.querySelector('.ml1 .letters');
    //textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    anime.timeline({loop: false})
      /*.add({
        targets: '.ml1 .letter',
        scale: [0.3,1],
        opacity: [0,1],
        translateZ: 0,
        easing: "easeOutExpo",
        duration: 600,
        delay: (el, i) => 70 * (i+1)
      })*/.add({
        targets: '.ml1 .line',
        scaleX: [0,1],
        opacity: [0.5,1],
        easing: "easeOutExpo",
        duration: 700,
        offset: '-=875',
        delay: (el, i, l) => 80 * (l - i)
      }).add({
        targets: '.ml1',
        opacity: 1,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000
      });
  },
  directives: {
      'b-tooltip': VBTooltip
  },
  data: function(){
    return {
        route : 'home' 
    } 
  },
  methods : {
    /**
    * Implement a simple scroll indicator on top of the document

    **/
    checkScrolling : function(){
      let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      let scrolled = (winScroll / height) * 100;
      $("#bar_progress").css('width' , `${scrolled}%`);
    }, 
    findRoute : function(){
      let uri     = window.location.pathname.split('/') ; 
      this.route = ( uri[uri.length-1].length > 2 ) ? uri[uri.length-1] : '' ;
    },
    switchTheme: function(theme) {
      $('body').attr('class',theme) ; 
    },
    goToTop: function(){
      // $(window).scrollTop(0) ; 
      $("html, body").animate({ scrollTop: 0 }, 750 ,function(){
        document.location.reload();
      });
    }
  }, 
  watch:{ 
      $route : function(to){
        if ( to.name != "home") 
          this.route = to.name ; 
        else
          this.findRoute();
      }
  }
}


</script>

<style lang="scss">

$blue_iarc: #1e7fb8 ; 

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

@font-face {
  font-family: "Frutiger-LT-65-Bold";
  src: url("assets/fonts/Frutiger-LT-65-Bold.woff") format("woff");
}

@font-face {
  font-family: "Frutiger-LT-Com-55-Roman";
  src: url("assets/fonts/Frutiger-LT-Com-55-Roman.woff") format("woff");
}

body{
  color: #fff ; 
  font-family: "Frutiger-LT-Com-55-Roman" !important;
  overflow-x: hidden; 
  overflow-y: auto ; 
}

body.dark{
  background: #383f59 ; /*linear-gradient(to right,#151A2F, #39425F);*/
  h1,h2,h3,h4{
    font-family: "Frutiger-LT-65-Bold"!important;
  }
  h1,h2,h3,h4,p,div{
    color: #fff ;   
  }
}

body.iarc{
  background: #fff ;
  h1,h2,h3,h4,p,div{
    color: #000 ; 
  }
  .top_heading{
    background: $blue_iarc; 
    width: 100%;
    height: 120px;
    padding: 20px;
    position: fixed;
    left: 0;
    z-index: -1;
  }

  header p.intro a.scroll span{
    border-color: #000 ; 
  }
  header p.intro a.scroll span:before{
    background-color: #000;
  }
}

body.opened{
  overflow-y: auto ; 
}

#loading{
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -40px; 
}

header.hidden_,#story.hidden_,footer.hidden_{
  opacity: 0 !important;
}

.progress-container {
  position: fixed ;
  width: 100%;
  height: 8px;
  background: #ccc;
  z-index: 2;
  .progress-bar {
    height: 8px;
    background: #ff7b17!important;
    width: 0%;
  }
}

select[name="theming"]{
  position: fixed ;
  right: 0 ; 
  top: 50px ; 
}

header{
  height: 100vh;
  h1.title{
    font-family: "Frutiger-LT-65-Bold";
    margin-top: 10px;
  }
  .ml1 {
    font-weight: 900;
    font-size: 2.8em;
    padding:30px 0;
    .letter {
      display: inline-block;
      line-height: 1em;
    }
    .text-wrapper {
      position: relative;
      display: inline-block;
      padding-top: 0.1em;
      padding-right: 0.05em;
      padding-bottom: 0.15em;
    }
    .line {
      opacity: 0;
      position: absolute;
      left: 0;
      height: 3px;
      width: 100%;
      background-color: #fff;
      transform-origin: 0 0;
    }
    .line1 { top: 0; }
    .line2 { bottom: 0; }
  }

  p.intro{
    padding: 20px 8%;
    position: relative ; 
    text-align: justify;
    font-size: 1em; 
    span.number{
      font-size: 1.2em;
      font-weight: 900;
    }
    a.scroll{
      position: absolute;
      bottom: -90px;
      left: 50%;
      padding-top: 60px;
      z-index: 2;
      display: inline-block;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      color: #fff;
      letter-spacing: .1em;
      text-decoration: none;
      transition: opacity .3s;
      span{
        position: absolute;
        top: 0;
        left: 50%;
        width: 30px;
        height: 50px;
        margin-left: -15px;
        border: 2px solid #fff;
        border-radius: 50px;
        box-sizing: border-box;
        &:before{
          position: absolute;
          top: 10px;
          left: 50%;
          content: '';
          width: 6px;
          height: 6px;
          margin-left: -3px;
          background-color: #fff;
          border-radius: 100%;
          animation: sdb10 2s infinite;
          box-sizing: border-box;
        }
      }
    }
  }
}

.row{
  width: 100%;
}

footer{
  a#goToTop{
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    -webkit-transition: 
    -webkit-transform .8s ease-in-out;
    transition: transform .8s ease-in-out;
    &:hover{
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
    i{
      font-size: 3em;
    }
  }
}

@keyframes sdb10 {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80% {
    transform: translate(0, 20px);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}



h1,h2{
  text-align: center;
  width: 100%; 
  display: block;
  float: left;
}

h1{
  font-weight: 900!important;
  padding:50px 0;
}

h2{
  font-size: 3em!important;
  font-weight: 500;
}

h3{
  text-align: center;
  font-size: 2.6em!important;
}

h4{
  text-align: center;  
  font-size: 1.6em!important;
  padding: 0 100px;
}

#a_logo{
  float: left;
  margin-top: 20px;
}


.overlay{
    display: none ; 
    position: absolute;
    top: 0 ;
    left: 0 ;
    width: 120% ;
    height: 120% ;
    z-index: 10 ;
    background-color: rgba(0,0,0,0.5); /*dim the background*/
    #spinLoading{
        text-align: center; 
        width: 280px; 
        position: absolute ;
        top : 50%; 
        left: 50%; 
        margin-left: -140px; 
        span{
            color: #000 ; 
            display: block ; 
            text-align: center ; 
        }
        i{
            color: #000;
            font-size: 2em ; 
        }
    }
}

/* Loader */
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1000ms infinite linear;
    animation: spin 1000ms infinite linear;
}
.fa-spin{
    width: 2em;
    color: #000;
    display: block; 
    margin: auto;
    text-align: center;
    margin-left: 110px;
    margin-top: 10px;
}

#app{
  padding: 0px ; 
  
  position: relative ;

  .container{
    margin: 0;
    position: relative;
  }

  .full{
    padding: 20px;
  }

  ul.social_home,ul.social{
    position: absolute;
    right: 0;
    top: -5px;
    li{
      display: inline-block;
      margin: 5px;
      i{
        font-size: 1.6em;
        color: #ffffff ;
      }
    }
  }

  ul.social{
    top: 55px;
  }

  ul.footer_links{
    padding-left:0px;
    li{
      display: inline-block;
      list-style-type: none;
      height: 30px;
      padding: 10px 20px 10px 50px;
      width: 100% ; 
      text-align: left ; 
      color: #3d3d3d;
      margin-bottom: 10px;
      &.terms{
        height: 10px!important;
        padding: 0px 20px 0px 50px!important;
        &:first-child{
          margin-top: 30px;
        }
      }
      h5{
        text-transform: uppercase;
        font-size: 1.4em; 
        font-weight: 800 ; 
      }
      a{
        color:#000!important;
        text-decoration: none;
        &:hover{
          color:#ccc;
          text-decoration: underline;
        }
      }
      i{
        color: #808080; 
        display: block; 
        float: left;
        font-size: 1.2em;
        margin: 3px 10px 0 0;
      }
      span.txt_contact{
        float: left; 
        display: block ; 
        line-height: 1.4em;
      }
      
    }
  } // end footer links
}

//@mixin for-phone-only {
@media (max-width: 540px) { 
  
}
//}
//@mixin for-tablet-portrait-up {
@media (max-width: 600px) { 

  body{
    line-height: 1.2em!important;
  }

  h1, header .ml1 {
    font-size: 1.4em !important;
  }

  a#a_logo{
    img{
      max-height: 40px;
    }
  }

  ul.social{
    top: 30px!important;
  }

  header p.intro{
    font-size: 1em!important;
    padding: 0 15px;
    a.scroll{
      bottom: -28%;
      margin-left: -24px;
    }
  }
  header h1.title{
    margin-bottom: 0;
    margin-top: 0;
    padding: 5% 0;
  }
  header .ml1 .text-wrapper{
    padding-top: 1em;
    padding-bottom:1em;
  }

  .scrollama-steps{
    display: none!important;
    .step{
      padding: 20vh 0!important;  
      width: 80%!important;
    }
  }

  .row{
    margin-left: 0px!important;
    margin-right: 0px!important;
  }

  #story .graphic .source{
    display: block!important;
    left: 10px !important;
    padding: 0 5px !important;
    width: 100%;
    display: block !important;
    left: 5px !important;
    padding: 0 5px !important;
    bottom: 26px!important;
    font-size: 0.5em!important;
    line-height: 11px;
  }

  #story .graphic h2, #story .graphic h3{
    padding: 5px 10px!important;
    font-size: 1em!important;
  }

  #story #scrollama-container-section_2 .graphic p.disclaimer{
    font-size: 0.6em!important;
    text-align: justify;
    bottom: 50px;
    padding: 0 10px!important;
    bottom: 40px!important;
  }

  #story .graphic h3{
    top: 45px!important;
  }

  #story .graphic p.desc{
    padding: 0 40px ;
    top: 110px !important;
    font-size:0.9em!important;
  }

  #story div.overlay{
    padding: 5px;
    h2{
      padding-top: 5px; 
    }
    a.close{
      top: 5px !important;
      right: 5px !important;
    }
    h2{
      text-align:left!important;
      font-size: 1.2em !important;
    }
    svg{
      text.y_title_left{
        font-size: 0.6em;
      }
    }
  }

  #story #scrollama-container-section_1{

    .graphic #viz1{
      .sunburst {
        height: 35vh!important;
        g.hidden_slice{
          opacity: 1!important;
        }
        h4{
          top: 80%!important;
          /* bottom: 65px; */
          padding: 0!important;
          font-size: 0.8em!important;
        }
        .main-text{
          display: none;
        }
        span.source{
          display: none!important;
        }
        
        .sunburst_legend{
          /*display: none!important;*/
          opacity: 1!important;
          font-size: 0.8em;
        }

        &#container_sunburst1{
          #sunburst_legend_3{
            top: 5px!important;
            right: 13% !important;
          }
          #sunburst_legend_4{
            top: 30px!important;
            right: 11% !important;
          }
          #sunburst_legend_5{
            top: 60px!important;
            right: 14%!important;
          }
          #sunburst_legend_6{
            top: 80px!important;
            right: 0%!important;
          }
          #sunburst_legend_7{
            top: 100px!important;
            right: 7% !important;
          }
        }

        &#container_sunburst2{
          #sunburst_legend_8{
            top: 5px!important;
            right: 13% !important;
          }
          #sunburst_legend_9{
            top: 30px!important;
            right:  11% !important;
          }
          #sunburst_legend_10{
            top: 70px!important;
            right: 14%!important;
          }
          #sunburst_legend_11{
            top: 110px!important;
            right: 0%!important;
          }
          #sunburst_legend_12{
            top: 140px!important;
            right: 7% !important;
          }
        }
      }
    }
  }

  #story #scrollama-container-section_2{
    .graphic p.desc{
      top: 150px!important;
      text-align: center;
    }

    h3{
      top: 75px!important;
    }

    g.legendOrdinalMap{
      text{
        font-size: .6em;
      }
    }
  }

  #story svg#graphic_3_1{
    g.legend_lines{
      display: none;
    }
  }

  #story #scrollama-container-section_3 .graphic{

    h3{
      top: 0px!important;
      padding-top: 20px!important;
    }

    #viz4{
      width: 100%!important;

      svg{
        margin-top: -40px!important;  
        g.legend_lines{
          display: none;
        } 
        text.y_title_left{
          font-size: 0.6em;
        }
      }
    }

    .legend_mobile{
      display: block!important;
      position: absolute;
      bottom: 50px;
      left: 20px;
      ul{
        height: 100px;
        li{
          list-style-type: none;
          font-size: 0.7em;
          display:block;
          margin-bottom: -3px;
          span{
            display: inline-block;
            width: 30px;
            height: 2px;
            margin-right: 5px;
          }
        }
      }
    }

    ul.legend{
      position: absolute;
      margin-top: 0;
      top: 80px;
      left: 50%;
      width: 400px;
      margin-left: -185px;
      li{
        display: inline-block;
        width: 20%;
        display: inline-block;
        margin: 0 0 10px 10px;
        a{
          font-size:0.8em;
        }
      }
    }
  }

  #story #scrollama-container-section_4 .graphic {
    #viz5{
      width: 100%!important;
      min-height: auto!important;
      flex-direction: column;
      svg{
        margin-top:50px;
      }
      text.text{
        font-size: 0.8em;
      }
     .legendOrdinal text{
      font-size: 0.8em!important;
      transform: translate(50px,25px);
     }
    }
    #viz5_desc{
      width: 100%!important;
      flex-direction: column;
      padding: 10px 10px !important;
      text-align: justify;
      .desc{
        padding:5px 0!important;
      }
      #text-5-1,#text-5-2{
        display: block!important;
        width: 100%!important;
        font-size: 0.8em;
        line-height: 14px;
        span.selected{
          height: 12px!important;
        }
      }
    }
  }

  #story #scrollama-container-section_5 .graphic {
    #viz6{
      width: 100%!important;
      min-height: auto!important;
      margin-top: 260px!important;
      .viz6{
        min-height: auto!important;
        margin-bottom: 20px;
        h4{
          opacity: 1!important;
          margin-bottom: 0px;
          margin-left: 0px!important;
          padding-left: 30px;
        }
        svg{
          text{
            font-size: 0.8em;
          }
          text.label{
            font-size: 0.6em;
          }
        }
      }
    }

    #viz6-2{
      opacity: 1!important;
    }
    #viz6_desc{
      display: none;
    }
  }

  #story #scrollama-container-section_6 .graphic{
    svg{
      text.y_title_left,text.y_title{
        font-size: 0.8em;
      }
    }
    #viz7{
      width: 100%!important;
      min-height:auto!important;
      height: 30vh;
      margin-top: 15vh;
      g.group_lines,g.annotations_colon,g.annotations_rectum{
        display: block!important;
      }
      text.annotation-note-title{
        font-size: 0.6em!important;
      }
      line#line_left_viz7,line#line_right_viz7
      {
        display: none;
      }
    }
    #viz7_desc{
      width: 100%!important;  
      margin-top: 0!important;
      font-size: 0.8em;
      .desc{
        padding: 10px 0 !important;
        span.subtext{
          display: block!important;
          font-size: 0.8em;
          .d_num,.d_rates{
            height: 16px!important;
          }
        }
      }
    }
  } 

}
//}

// for tablet & mobile
@media (min-width:600) and (max-width: 900px) { 
  h1,header .ml1{
    font-size:2em!important ; 
  }
  header p.intro{
    padding: 10px 8%;
  }

}

@media (max-width: 900px) { 

  html,body{
    overflow-x: hidden;
  }
}


//@mixin for-tablet-landscape-up {
@media (min-width: 900px) { 
}

@media (min-width: 992px){
  .container, .container-sm, .container-md, .container-lg {
      max-width: 100%!important;
  }
}

@media (max-width: 1280px){
  #story #scrollama-container-section_5 .graphic #viz6{
    /*margin-top: 100px!important;*/
  }
  #story #scrollama-container-section_5 .graphic #viz6 .viz6{
    min-height: 200px!important;
  }
}

//}
//@mixin for-desktop-up {
@media (min-width: 1200px) { 
  #app .container {
    width: 1280px;
    padding: 20px ;
    margin: auto; 

  }
  h1{
    font-size: 4em!important;
  }
  ul.social{
    top: 30px!important;
  }
}
//}
@media (min-width: 1680px) { 
  header p.intro{
    padding: 20px 15%!important;
    font-size: 1.2em!important;
  }
  header p.intro a.scroll{
    bottom: -150px;
  }
}

</style>
